import { render, staticRenderFns } from "./LiveSaleRef.vue?vue&type=template&id=b18a2c14"
import script from "./LiveSaleRef.vue?vue&type=script&lang=js"
export * from "./LiveSaleRef.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports